import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col, Button, Dropdown, Form, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { isBrowser } from "react-device-detect";

//STYLES
import * as ProductDetailsStyles from "../styles/productDetails";

//COMPONENTS
import PhotoBox from "./photoBox";
import * as CurrencyMethods from "../../../../admin/files/currencyMethods";

//ACTIONS
import * as AccessModalActions from "../../../../../../envStore/actions/accessModal";
import * as PrintingShopActions from "../../../../../../envStore/actions/3dPrintingShop";

function ProductDetails() {
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [details, setDetails] = useState({});
    const [photos, setPhotos] = useState([]);
    const [quantity, setQuantity] = useState(1);

    const user = useSelector((state) => state.user);
    const printingShop = useSelector((state) => state.printingShop);

    const [purchaseType, setPurchaseType] = useState("");

    const depositModalDefaults = {
        open: false,
        deposits: 0,
        currentItem: {},
        newItem: {}
    };
    const [depositModal, setDepositModal] = useState(depositModalDefaults);

    function handleDepositModalClose() {
        setDepositModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    const [customForm, setCustomForm] = useState({
        elements: {
            colours: [],
            fields: []
        },
        values: {},
        valids: {},
        colorCustomActive: false,
        active: false,
        errorOnForm: false
    });

    useEffect(() => {
        dispatch(PrintingShopActions.ToggleBottomButtonsOpactiy(0));
        onLoad();
    }, []);

    function onLoad() {
        const data = { code: params.code };
        Axios.post("/pods/3dPrintingShop/frontEnd/getOneProduct", data)
            .then((res) => {
                const data = res.data;
                console.log("product details: ", data);
                data.product.depositActive = data.product.depositActive == "true";
                data.product.onlyShowDeposit = data.product.onlyShowDeposit == "true";
                setDetails(data.product);
                setPhotos(data.photos);

                //customisation
                if (data.product.colours.length > 1 || data.product.customFields.length > 0) {
                    let elements = {
                        colours: [],
                        fields: []
                    };
                    let values = {};
                    let valids = {};
                    let active = false;

                    if (data.product.colours.length > 1) {
                        elements.colours = data.product.colours;
                        if (!data.product.colorCustomActive) {
                            values.selectedColour = "Select Colour";
                            valids.colour = false;
                        }

                        active = true;
                    }

                    if (data.product.customFields.length > 0) {
                        elements.fields = data.product.customFields;

                        for (const [index, field] of data.product.customFields.entries()) {
                            if (field.type == "colour") {
                                values[`field_${index}`] = "Select a colour";
                            } else {
                                values[`field_${index}`] = "";
                            }
                            valids[`field_${index}`] = false;
                        }

                        active = true;
                    }

                    setCustomForm((prevState) => {
                        return { ...prevState, colorCustomActive: data.product.colorCustomActive, elements, values, valids, active };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleSelectColour(color) {
        const values = customForm.values;
        const valids = customForm.valids;

        values.selectedColour = color;
        valids.colour = true;

        setCustomForm((prevState) => {
            return { ...prevState, values, valids };
        });
    }

    function selectedCustomColour(field, color) {
        const values = customForm.values;
        const valids = customForm.valids;

        values[field] = color;
        valids[field] = true;

        setCustomForm((prevState) => {
            return { ...prevState, values, valids };
        });
    }

    function handleTextBoxOnChange(event) {
        const { name, value } = event.target;

        const values = customForm.values;
        const valids = customForm.valids;

        let isValid = false;
        if (value.length > 0) {
            isValid = true;
        }

        values[name] = value;
        valids[name] = isValid;

        setCustomForm((prevState) => {
            return { ...prevState, values, valids };
        });
    }

    function handleAddToCart(priceStatus) {
        if (customForm.active) {
            const customFormAllTrue = Object.keys(customForm.valids).every(function (k) {
                return customForm.valids[k] === true;
            });

            if (!customFormAllTrue) {
                setCustomForm((prevState) => {
                    return { ...prevState, errorOnForm: true };
                });
            } else {
                setCustomForm((prevState) => {
                    return { ...prevState, errorOnForm: false };
                });
                handleAddProductToCart(priceStatus);
            }
        } else {
            handleAddProductToCart(priceStatus);
        }
    }

    function handleAddProductToCart(priceStatus) {
        setPurchaseType(priceStatus);

        const data = {
            userID: user.id,
            productCode: details.productCode,
            quantity,
            priceStatus: priceStatus,
            customItem: customForm.active.toString(),
            linkedToOrderItemUUID: ""
        };
        const customData = [];

        if (customForm.active) {
            if (customForm.elements.colours.length > 0 && !customForm.colorCustomActive) {
                customData.push({
                    fieldName: "Colour",
                    type: "dColour",
                    value: customForm.values.selectedColour
                });
            }

            for (const [index, file] of Object.entries(customForm.elements.fields)) {
                customData.push({
                    fieldName: file.fieldName,
                    type: file.type,
                    value: customForm.values[`field_${index}`]
                });
            }
        }
        data.customData = customData;

        if (user.auth) {
            Axios.post("/pods/3dPrintingShop/frontEnd/addProductToBasket", data)
                .then((res) => {
                    const resData = res.data;
                    if (resData.error == "DEPOSIT") {
                        data.placementCode = resData.placementCode;
                        setDepositModal((prevState) => {
                            return { open: true, deposits: resData.deposits, currentItem: resData.item, newItem: data };
                        });
                    }
                    if (resData.error == "null") {
                        dispatch(PrintingShopActions.UpdateBasketItemTotal());

                        dispatch(PrintingShopActions.ToggleBasketSuccess(true));
                        dispatch(PrintingShopActions.ToggleBottomButtonsOpactiy(1));

                        setTimeout(() => {
                            dispatch(PrintingShopActions.ToggleBasketSuccess(false));
                        }, 2000);
                    }
                })
                .catch((err) => console.log(err));
        } else {
            const actions = { action: "addItemToBasket", data: data };
            dispatch(AccessModalActions.LogActionsAndSignIn(actions));
        }
    }

    function handleDepositItemClick(option) {
        const data = { option: option, currentItem: depositModal.currentItem, newItem: depositModal.newItem };
        Axios.post("/pods/3dPrintingShop/frontEnd/basketDepositItem", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setDepositModal(depositModalDefaults);

                    dispatch(PrintingShopActions.UpdateBasketItemTotal());

                    dispatch(PrintingShopActions.ToggleBasketSuccess(true));
                    dispatch(PrintingShopActions.ToggleBottomButtonsOpactiy(1));

                    setTimeout(() => {
                        dispatch(PrintingShopActions.ToggleBasketSuccess(false));
                    }, 2000);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleIncreaseQuantity() {
        setQuantity(quantity + 1);
    }

    function handleDecreaseQuantity() {
        if (quantity != 1) {
            setQuantity(quantity - 1);
        }
    }

    function handleContinueShopping() {
        navigate(-1);
    }

    function handleGoToBasket() {
        navigate("/basket");
    }

    const browserDisplay = (
        <Row>
            <Col sm={2}></Col>
            <Col sm={8}>
                <p style={ProductDetailsStyles.topProductCode}>Product Code: {details.productCode}</p>
                <h1 style={ProductDetailsStyles.title}>{details.title}</h1>
                <br />
                <Row>
                    <Col>
                        <strong>Description:</strong> <br /> <br />
                        {details.description}
                        <br />
                        {details.designer && (
                            <div style={ProductDetailsStyles.columnRight}>
                                <strong>Designer: </strong>
                                {details.designer}
                            </div>
                        )}
                        <br />
                        <strong>Specifications</strong>
                        <br /> <br />
                        Weight: {details.totalWeight} <br />
                        Time to build: {details.totalTime} (hours, minutes) <br /> <br />
                        {details.colours != null && details.colours.length == 1 && (
                            <div>
                                <strong>Colour:</strong> <br />
                                This product comes in {details.colours[0].name}
                            </div>
                        )}
                        <h2 style={ProductDetailsStyles.price}>£{CurrencyMethods.FormatCurrency(details.price)}</h2>
                        {details.depositActive && (
                            <h5 style={ProductDetailsStyles.price}>
                                Deposit Available ({details.depositPercentage}%): £
                                {CurrencyMethods.FormatCurrency(CurrencyMethods.WorkOutDepositPrice(details.price, details.depositPercentage))}
                            </h5>
                        )}
                        {customForm.active && (
                            <div>
                                <strong>Customisation</strong> <br />
                                <br />
                                <Row>
                                    {customForm.elements.colours.length > 1 && (
                                        <Col>
                                            {customForm.colorCustomActive ? (
                                                <div>
                                                    {customForm.elements.fields.map((field, index) => {
                                                        return (
                                                            <div key={index}>
                                                                {/* {index != 0 && <br />} */}
                                                                {field.type == "colour" && (
                                                                    <Form.Group>
                                                                        <Row>
                                                                            <Col>
                                                                                <Form.Label>{field.fieldName}:</Form.Label>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col>
                                                                                <Dropdown>
                                                                                    <Dropdown.Toggle
                                                                                        variant={
                                                                                            customForm.errorOnForm &&
                                                                                            !customForm.valids[`field_${index}`]
                                                                                                ? "danger"
                                                                                                : "primary"
                                                                                        }
                                                                                    >
                                                                                        {customForm.values[`field_${index}`]}
                                                                                    </Dropdown.Toggle>
                                                                                    <Dropdown.Menu>
                                                                                        {customForm.elements.colours.map((colour, cIndex) => {
                                                                                            return (
                                                                                                <Dropdown.Item
                                                                                                    key={cIndex}
                                                                                                    onClick={selectedCustomColour.bind(
                                                                                                        this,
                                                                                                        `field_${index}`,
                                                                                                        colour.name
                                                                                                    )}
                                                                                                >
                                                                                                    {colour.name}
                                                                                                </Dropdown.Item>
                                                                                            );
                                                                                        })}
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </Col>
                                                                        </Row>
                                                                    </Form.Group>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div>
                                                    Colour:
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant={customForm.errorOnForm && !customForm.valids.colour ? "danger" : "primary"}
                                                        >
                                                            {customForm.values.selectedColour}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {customForm.elements.colours.map((colour, index) => {
                                                                return (
                                                                    <Dropdown.Item key={index} onClick={handleSelectColour.bind(this, colour.name)}>
                                                                        {colour.name}
                                                                    </Dropdown.Item>
                                                                );
                                                            })}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            )}
                                        </Col>
                                    )}
                                    {customForm.elements.fields.length > 0 && (
                                        <Col>
                                            {customForm.elements.fields.map((field, index) => {
                                                return (
                                                    <div key={index}>
                                                        {index != 0 && <br />}
                                                        {field.type == "text" && (
                                                            <Form.Group>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Label>{field.fieldName}:</Form.Label>
                                                                    </Col>
                                                                    <Col>
                                                                        <p style={ProductDetailsStyles.counter}>
                                                                            {field.length - customForm.values[`field_${index}`].length}/{field.length}
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Control
                                                                            type="text"
                                                                            isInvalid={
                                                                                customForm.errorOnForm && !customForm.valids[`field_${index}`]
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            name={`field_${index}`}
                                                                            value={customForm.values[`field_${index}`]}
                                                                            maxLength={field.length}
                                                                            onChange={handleTextBoxOnChange}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Form.Group>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        )}
                        <br />
                        <p style={customForm.errorOnForm ? ProductDetailsStyles.showError : ProductDetailsStyles.hideError}>
                            Please correct the errors in above customisation
                        </p>
                        <Row>
                            <Col style={ProductDetailsStyles.quantitySection}>
                                Quantity: <br />
                                <Button onClick={handleDecreaseQuantity}>-</Button>
                                <Form.Label style={ProductDetailsStyles.quantityText}>{quantity}</Form.Label>
                                <Button onClick={handleIncreaseQuantity}>+</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {details.depositActive ? (
                                    <div>
                                        {details.onlyShowDeposit ? (
                                            <div>
                                                <Button
                                                    style={{ width: "100%" }}
                                                    variant={printingShop.basketSuccess && purchaseType == "dp" ? "success" : "primary"}
                                                    onClick={handleAddToCart.bind(this, "dp")}
                                                >
                                                    {printingShop.basketSuccess && purchaseType == "dp"
                                                        ? "Deposit Added To Basket"
                                                        : "Add Deposit to basket"}
                                                </Button>
                                            </div>
                                        ) : (
                                            <div style={{ textAlign: "center" }}>
                                                <h5>Purchasing Options</h5>
                                                <Button
                                                    style={{ width: "45%" }}
                                                    variant={printingShop.basketSuccess && purchaseType == "dp" ? "success" : "primary"}
                                                    onClick={handleAddToCart.bind(this, "dp")}
                                                >
                                                    {printingShop.basketSuccess && purchaseType == "dp" ? "Deposit Added" : "Add Deposit"}
                                                </Button>
                                                <Button
                                                    style={{ width: "45%" }}
                                                    variant={printingShop.basketSuccess && purchaseType == "fp" ? "success" : "primary"}
                                                    onClick={handleAddToCart.bind(this, "fp")}
                                                >
                                                    {printingShop.basketSuccess && purchaseType == "fp" ? "Full Price Added" : "Add Full Price"}
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div>
                                        <Button
                                            style={{ width: "100%" }}
                                            variant={printingShop.basketSuccess && purchaseType == "fp" ? "success" : "primary"}
                                            onClick={handleAddToCart.bind(this, "fp")}
                                        >
                                            {printingShop.basketSuccess && purchaseType == "fp" ? " Item Added To Basket" : "Add To Basket"}
                                        </Button>
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <Row style={{ ...ProductDetailsStyles.bottomButtons, opacity: printingShop.bottomButtonsOpacity }}>
                            <Col>
                                <Button style={{ width: "100%" }} onClick={handleGoToBasket}>
                                    Go To Basket
                                </Button>
                            </Col>
                            <Col>
                                <Button style={{ width: "100%" }} onClick={handleContinueShopping}>
                                    Continue Shopping
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col style={ProductDetailsStyles.photoContainer}>
                        <PhotoBox images={photos} uuid={details.uuid} />
                    </Col>
                </Row>
            </Col>
            <Col sm={2}></Col>
        </Row>
    );
    const mobileDisplay = (
        <div>
            <div>Product Code: {details.productCode}</div>
            <br />
            <h1 style={ProductDetailsStyles.title}>{details.title}</h1>
            <div style={ProductDetailsStyles.mobile_photoBox}>
                <PhotoBox images={photos} uuid={details.uuid} />
            </div>
            <div style={ProductDetailsStyles.mobile_description}>
                <strong>Description:</strong> <br /> <br />
                {details.description}
                <br /> <br />
                <strong>Specifications</strong>
                <br /> <br />
                Weight: {details.totalWeight} <br />
                Time to build: {details.totalTime} (hours, minutes) <br /> <br />
                {details.colours != null && details.colours.length == 1 && (
                    <div>
                        <strong>Colour:</strong> <br />
                        This product comes in {details.colours[0].name}
                    </div>
                )}
                <h2 style={ProductDetailsStyles.price}>£{CurrencyMethods.FormatCurrency(details.price)}</h2>
                {details.depositActive && (
                    <h5 style={ProductDetailsStyles.price}>
                        Deposit Available ({details.depositPercentage}%): £
                        {CurrencyMethods.FormatCurrency(CurrencyMethods.WorkOutDepositPrice(details.price, details.depositPercentage))}
                    </h5>
                )}
            </div>
            {customForm.active && (
                <div style={ProductDetailsStyles.mobile_description}>
                    <strong>Customisation</strong> <br />
                    <br />
                    {customForm.elements.colours.length > 1 && (
                        <div>
                            Colour:
                            <Dropdown>
                                <Dropdown.Toggle variant={customForm.errorOnForm && !customForm.valids.colour ? "danger" : "primary"}>
                                    {customForm.values.selectedColour}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {customForm.elements.colours.map((colour, index) => {
                                        return (
                                            <Dropdown.Item key={index} onClick={handleSelectColour.bind(this, colour.name)}>
                                                {colour.name}
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    )}
                    <br />
                    {customForm.elements.fields.length > 0 && (
                        <div>
                            {customForm.elements.fields.map((field, index) => {
                                return (
                                    <div key={index}>
                                        {index != 0 && <br />}
                                        <Form.Group>
                                            <Row>
                                                <Col>
                                                    <Form.Label>{field.fieldName}:</Form.Label>
                                                </Col>
                                                <Col>
                                                    <p style={ProductDetailsStyles.counter}>
                                                        {field.length - customForm.values[`field_${index}`].length}/{field.length}
                                                    </p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Control
                                                        type="text"
                                                        isInvalid={customForm.errorOnForm && !customForm.valids[`field_${index}`] ? true : false}
                                                        name={`field_${index}`}
                                                        value={customForm.values[`field_${index}`]}
                                                        maxLength={field.length}
                                                        onChange={handleTextBoxOnChange}
                                                    />
                                                </Col>
                                            </Row>
                                        </Form.Group>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
            <p style={customForm.errorOnForm ? ProductDetailsStyles.showError : ProductDetailsStyles.hideError}>
                Please correct the errors in above customisation
            </p>
            <div style={ProductDetailsStyles.quantitySection}>
                Quantity: <br />
                <Button onClick={handleDecreaseQuantity}>-</Button>
                <Form.Label style={ProductDetailsStyles.quantityText}>{quantity}</Form.Label>
                <Button onClick={handleIncreaseQuantity}>+</Button>
            </div>
            <Row>
                <Col>
                    {details.depositActive ? (
                        <div>
                            {details.onlyShowDeposit ? (
                                <div>
                                    <Button
                                        style={{ width: "100%" }}
                                        variant={printingShop.basketSuccess && purchaseType == "dp" ? "success" : "primary"}
                                        onClick={handleAddToCart.bind(this, "dp")}
                                    >
                                        {printingShop.basketSuccess && purchaseType == "dp" ? "Deposit Added To Basket" : "Add Deposit to basket"}
                                    </Button>
                                </div>
                            ) : (
                                <div style={{ textAlign: "center" }}>
                                    <h5>Purchasing Options</h5>
                                    <Button
                                        style={{ width: "45%" }}
                                        variant={printingShop.basketSuccess && purchaseType == "dp" ? "success" : "primary"}
                                        onClick={handleAddToCart.bind(this, "dp")}
                                    >
                                        {printingShop.basketSuccess && purchaseType == "dp" ? "Added" : "Add Deposit"}
                                    </Button>
                                    <Button
                                        style={{ width: "45%" }}
                                        variant={printingShop.basketSuccess && purchaseType == "fp" ? "success" : "primary"}
                                        onClick={handleAddToCart.bind(this, "fp")}
                                    >
                                        {printingShop.basketSuccess && purchaseType == "fp" ? "Added" : "Add Full Price"}
                                    </Button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div>
                            <Button
                                style={{ width: "100%" }}
                                variant={printingShop.basketSuccess && purchaseType == "fp" ? "success" : "primary"}
                                onClick={handleAddToCart.bind(this, "fp")}
                            >
                                {printingShop.basketSuccess && purchaseType == "fp" ? " Item Added To Basket" : "Add To Basket"}
                            </Button>
                        </div>
                    )}
                </Col>
            </Row>
            <div style={{ ...ProductDetailsStyles.mobile_bottomButtons, opacity: printingShop.bottomButtonsOpacity }}>
                <Button style={{ width: "100%" }} onClick={handleGoToBasket}>
                    Go To Basket
                </Button>
            </div>
            <div style={{ ...ProductDetailsStyles.mobile_bottomButtons, opacity: printingShop.bottomButtonsOpacity }}>
                <Button style={{ width: "100%" }} onClick={handleContinueShopping}>
                    Continue Shopping
                </Button>
            </div>
        </div>
    );

    return (
        <div style={{ height: "100%", overflow: "scroll" }}>
            {isBrowser ? browserDisplay : mobileDisplay}
            <Modal show={depositModal.open} onHide={handleDepositModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Deposit Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {depositModal.deposits > 1 ? (
                        <div>
                            There are already {depositModal.deposits} of this item in your basket, for which you are paying the deposit cost. The
                            system will change these items to full price before adding additional fully priced items in your basket, to your desired
                            quantity. Do you want to continue? <br /> (If you click no, the full cost item(s) will be additional to the item(s) you
                            have already have in your basket)
                        </div>
                    ) : (
                        <div>
                            This item is already in your basket, for which you are paying the deposit cost. The system will change this item to full
                            price before adding additional fully priced items in your basket, to your desired quantity. Do you want to continue?{" "}
                            <br /> (If you click no, the full cost item(s) will be additional to the item(s) you have already have in your basket)
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleDepositItemClick.bind(this, "no")}>No</Button>
                    <Button onClick={handleDepositItemClick.bind(this, "yes")}>Yes</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ProductDetails;
